import type { IconSvgObject } from './types';

const TextCircleIcon: IconSvgObject = [
  ["path", { d: "M10.3185 16.9775H11.9666M11.9666 16.9775H13.6311M11.9666 16.9775V7.4986M7.00584 9.21775C6.86814 8.16066 7.14404 7.69382 8.11601 7.43245C10.6066 6.76269 13.3087 6.87472 15.8125 7.49286C16.7555 7.72567 17.0775 8.14056 16.9437 9.21775", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default TextCircleIcon;
